export default __webpack_public_path__ + "static/media/20Years_1@2x.9989c2f5.jpg";